export class SystemLog {
    ID: number;
    UserID: number;
    Timestamp: Date;
    MachineName: string;
    InstanceName: string;
    ProgramName: string;
    Type: string;
    Message: string;
    StackTrace: string;
    Context: string;
   }